import types from './types';

// Zones
const getZones = projectId => ({ type: types.GET_ZONES, payload: projectId });
const getZonesSuccess = zones => ({ type: types.GET_ZONES_SUCCESS, payload: zones });
const getZonesFailure = error => ({ type: types.GET_ZONES_FAILURE, payload: error });

const createZone = (projectId, zoneData) => ({ type: types.CREATE_ZONE, payload: { projectId, zoneData } });
const createZoneSuccess = zone => ({ type: types.CREATE_ZONE_SUCCESS, payload: zone });
const createZoneFailure = error => ({ type: types.CREATE_ZONE_FAILURE, payload: error });

const updateZone = (zoneId, zoneData) => ({ type: types.UPDATE_ZONE, payload: { zoneId, zoneData } });
const updateZoneSuccess = zone => ({ type: types.UPDATE_ZONE_SUCCESS, payload: zone });
const updateZoneFailure = error => ({ type: types.UPDATE_ZONE_FAILURE, payload: error });

const deleteZone = (zoneId, projectId) => ({ type: types.DELETE_ZONE, payload: { zoneId, projectId } });
const deleteZoneSuccess = () => ({ type: types.DELETE_ZONE_SUCCESS });
const deleteZoneFailure = error => ({ type: types.DELETE_ZONE_FAILURE, payload: error });

// Assessment
const runAssessment = projectId => ({ type: types.RUN_ASSESSMENT, payload: projectId });
const runAssessmentSuccess = result => ({ type: types.RUN_ASSESSMENT_SUCCESS, payload: result });

// UBHPS
const getUbhpsFeatures = (projectId, zoneId) => ({ type: types.GET_UBHPS_FEATURES, payload: { projectId, zoneId } });
const getUbhpsFeaturesSuccess = features => ({ type: types.GET_UBHPS_FEATURES_SUCCESS, payload: features });
const getUbhpsFeaturesFailure = error => ({ type: types.GET_UBHPS_FEATURES_FAILURE, payload: error });

const updateUbhpsFeatures = (projectId, zoneId, features) => ({ type: types.UPDATE_UBHPS_FEATURES, payload: { projectId, zoneId, features } });
const updateUbhpsFeaturesSuccess = () => ({ type: types.UPDATE_UBHPS_FEATURES_SUCCESS });
const updateUbhpsFeaturesFailure = error => ({ type: types.UPDATE_UBHPS_FEATURES_FAILURE, payload: error });

// Impact
const setCommunityImpact = data => ({ type: types.SET_COMMUNITY_IMPACT, payload: data });

export default {
  getZones, getZonesSuccess, getZonesFailure,
  createZone, createZoneSuccess, createZoneFailure,
  updateZone, updateZoneSuccess, updateZoneFailure,
  deleteZone, deleteZoneSuccess, deleteZoneFailure,
  runAssessment, runAssessmentSuccess,
  getUbhpsFeatures, getUbhpsFeaturesSuccess, getUbhpsFeaturesFailure,
  updateUbhpsFeatures, updateUbhpsFeaturesSuccess, updateUbhpsFeaturesFailure,
  setCommunityImpact,
};
